import React from 'react'
import { Fade } from 'react-awesome-reveal'

function Benifits() {
    return (
        <section className="section-benefits padding-t-100 padding-b-50">
            <img src="assets/img/benefits/benefits-shape-4.png" alt="Benefits-shape-4" className="benefits-shape-4" />
            <img src="assets/img/benefits/benefits-shape-6.png" alt="Benefits-shape-6" className="benefits-shape-6" />
            <img src="assets/img/benefits/benefits-shape-7.png" alt="Benefits-shape-7" className="benefits-shape-7" />
            <div className="container">
                <div className="row">
                    <Fade triggerOnce duration={1500} direction='up' className="zx-app-banner">
                        <h4 className="center">Best IT Benefits</h4>
                        <h2 className="center">What The Benefits To Install <br></br> This App!</h2>
                    </Fade>
                    <Fade triggerOnce duration={1500} direction='up' className="col-lg-4 col-sm-12 main-plan">
                        <div className="zx-app-benefits">
                            <h4>Photo uploading<br></br>option in our application</h4>
                            <p>
                                Lorem ipsum dolor sit amet consectetur<br></br>adipisicing elit.
                                saepe sunt tempore<br></br>
                                reiciendis reprehenderit?
                            </p>
                            <img src="assets/img/benefits/benefits-1.png" alt="benefits-1" />
                        </div>
                    </Fade>
                    <Fade triggerOnce duration={1500} direction='up' className="col-lg-4 col-sm-12 main-plan" data-aos="fade-up" data-aos-duration="1500">
                        <div className="zx-app-benefits">
                            <h4>QR Code varification<br></br>when you want to access</h4>
                            <p>
                                Lorem ipsum dolor sit amet consectetur<br></br>adipisicing elit.
                                saepe sunt tempore<br></br>
                                reiciendis reprehenderit?
                            </p>
                            <img src="assets/img/benefits/benefits-2.png" alt="benefits-2" />
                        </div>
                    </Fade>
                    <Fade triggerOnce duration={1500} direction='up' className="col-lg-4 col-sm-12 main-plan">
                        <div className="zx-app-benefits">
                            <h4>Defalut ui looking<br></br>good in our application</h4>
                            <p>
                                Lorem ipsum dolor sit amet consectetur<br></br>adipisicing elit.
                                saepe sunt tempore<br></br>
                                reiciendis reprehenderit?
                            </p>
                            <img src="assets/img/benefits/benefits-3.png" alt="benefits-3" />
                        </div>
                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Benifits
